import { useLottie } from "hooks/useLottie";
import { FC } from "react";
import { File } from "react-bricks/frontend";
import styled from "styled-components";

type Props = {
  propName: string;
  maxWidth?: string;
};

const LottieUploadedImage: FC<Props> = ({ propName, maxWidth }) => {
  return (
    <File
      propName={propName}
      allowedExtensions={[".json"]}
      renderBlock={(props) => {
        if (!props?.url) {
          return <Upload>Upload Lottie JSON</Upload>;
        }

        return (
          <div>
            <Lottie url={props?.url} maxWidth={maxWidth} />
          </div>
        );
      }}
    />
  );
};

export default LottieUploadedImage;

const Lottie = ({ url, maxWidth }: { url: string; maxWidth?: string }) => {
  const ref = useLottie(url);
  return <ImageWrapper ref={ref} maxWidth={maxWidth} />;
};

const ImageWrapper = styled.div<{ maxWidth?: string }>`
  width: ${(p) => p.maxWidth};
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const Upload = styled.div`
  width: 200px;
  height: 300px;
  background-color: #f0f0f0;
`;
